module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Send-26e68f97dafc8fd4c807bf4e26bfc943.svg";